module.exports = __webpack_public_path__ + "img/Syrenis-white.a14782ac.svg";